const content = {
    instacart_order_history: {
        en: {
            summary_html: "<p>Retro jobs are simple, quick and a bit of fun too. Watch the video and read the steps below, and then you're ready to hit record and do your Retro thing.</p>",
            summary_no_video_html: "<p>Retro jobs are simple, quick and a bit of fun too. Read the steps below, and then you're ready to hit record and do your Retro thing.</p>",
            steps: [
              {
                step_type: 'numbered_step',
                number: '1',
                description_html: '<p>Do some things.</p>'
              },
              {
                step_type: 'numbered_step',
                number: '2',
                description_html: '<p>Do more things.</p>'
              }
            ],
        }
    }
};

export const instacartDataTypes = {
    'instacart_order_history': {
        data_type: 'instacart_order_history',
        data_type_description: 'Instacart Order History',
        logo: 'https://d3s00xghdjywqy.cloudfront.net/c2/retro/instacart-order-history/logo.png',
        capture_type: 'video',
        ios: {
            use_in_app_screen_recorder: false,
            ...content.instacart_order_history,
        },
        android: {
            use_in_app_screen_recorder: true,
            ...content.instacart_order_history,
        }
      },
}

